/* eslint-disable @angular-eslint/component-max-inline-declarations */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DsBadge, DsBadgeSize, DsBadgeVariant } from '@frontend/ui/badge';

export type StcikerStyles = {
    [key: string]: string | undefined;
};
@Component({
    selector: 'cs-badge',
    template: `
        @for (badge of badges(); track badge.value; let i = $index) {
            @if (isLegacy()) {
                <b id="cs-badge-text" class="cs-badge-text" [style]="enableStickerStyles() ? getStickerStyles(i) : getStyles(badge.value, i)">
                    {{ badge.value }}
                </b>
            } @else {
                <ds-badge [variant]="variant()" [size]="size()">{{ badge.value }}</ds-badge>
            }
        }
    `,
    styleUrl: './badge.component.scss',
    imports: [DsBadge],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsBadgeComponent {
    size = input.required<DsBadgeSize>();
    variant = input.required<DsBadgeVariant>();
    isLegacy = input<boolean>(false);
    badges = input.required<Array<{ value: string }>>();
    stickerStyles = input.required<StcikerStyles>();
    isUk = input<boolean>(false);
    enableStickerStyles = input<boolean>(true);

    getStickerStyles(index: number) {
        if (this.isUk()) {
            return index % 2 === 0 ? this.stickerStyles()['UkStickerStyle1'] : this.stickerStyles()['UkStickerStyle2'];
        } else {
            return this.stickerStyles()['GameStickerStyle'];
        }
    }

    getStyles(sticker: any, index: number): string | undefined {
        const stickerKey = Object.keys(this.stickerStyles() || '');
        if (stickerKey.includes(sticker)) {
            return this.stickerStyles()[sticker];
        } else if (this.isUk()) {
            return index % 2 === 0 ? this.stickerStyles()['UkStickerStyle1'] : this.stickerStyles()['UkStickerStyle2'];
        } else {
            return this.stickerStyles()['GameStickerStyle'];
        }
    }
}
